import { render, staticRenderFns } from "./questionnaireEmpselect.vue?vue&type=template&id=52a480d9&scoped=true&"
import script from "./questionnaireEmpselect.vue?vue&type=script&lang=js&"
export * from "./questionnaireEmpselect.vue?vue&type=script&lang=js&"
import style0 from "./questionnaireEmpselect.vue?vue&type=style&index=0&id=52a480d9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a480d9",
  null
  
)

export default component.exports